import {Component} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  AddFeedbackDto, ErrorSeverityType,
  FeedbackClient, FeedbackSeverityType,
  FeedbackType, HealthClient, MissingFeatureSeverityType,
} from '../../../api/api-client';
import {RadioButtonModule} from 'primeng/radiobutton';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {TextareaModule} from 'primeng/textarea';
import {CheckboxModule} from 'primeng/checkbox';

import {ButtonDirective} from 'primeng/button';
import {Ripple} from 'primeng/ripple';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FeedbackDataService} from '../../../services/feedback-data.service';
import {SelectButtonModule} from 'primeng/selectbutton';
import {feedbackSeverityValidator} from '../../../validators/feedback-severity.validator';
import {errorSeverityValidator} from '../../../validators/error-severity.validator';
import {missingFeatureSeverityValidator} from '../../../validators/missing-feature-severity.validator';
import {environment} from '../../../environments/environment';
import {SubscriptionManager} from '../../../services/subscription-manager.service';

@Component({
  selector: 'app-feedback-widget',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextareaModule,
    TranslationPipe,
    TextareaModule,
    CheckboxModule,
    ButtonDirective,
    SelectButtonModule,
    RadioButtonModule,
    Ripple
  ],
  providers: [TranslationPipe, SubscriptionManager],
  templateUrl: './feedback-widget.component.html',
  styleUrl: './feedback-widget.component.scss'
})
export class FeedbackWidgetComponent {

  formSubmitted = false;

  feedbackTypeOptions!: any[];
  feedbackSeverityOptions!: any[];
  errorSeverityOptions!: any[];
  missingFeatureSeverityOptions!: any[];

  frontendVersion: string = environment.version;
  backendVersion!: string;

  createFeedbackForm: FormGroup = new FormGroup({
    // feedbackType:new FormControl<FeedbackType | null>(null, [Validators.required]),
    // feedbackSeverity:new FormControl<NullableOfFeedbackSeverityType | null>(null),
    // errorSeverity: new FormControl<NullableOfErrorSeverityType | null>(null),
    // missingFeatureSeverity: new FormControl<NullableOfMissingFeatureSeverityType | null>(null),
    // description:new FormControl<string>("", [Validators.required]),
    // concerningPage: new FormControl<string>("", [Validators.required]),
    // concerningPetId: new FormControl<string>(""),
    // concerningCustomerId: new FormControl<string>(""),
    // concerningTreatmentId:new FormControl<string>(""),
    // hasPermissionToAccessData:new FormControl<boolean>(false),
    // hasPermissionToContact:new FormControl<boolean>(false)
  });

  constructor(
    private readonly subscriptionManager: SubscriptionManager,
    private readonly dialogService: DialogService,
    private readonly ref: DynamicDialogRef,
    private readonly feedbackService: FeedbackClient,
    protected feedbackDataService: FeedbackDataService,
    private readonly transPipe: TranslationPipe,
    private readonly healthClient: HealthClient
  ) {
    this.feedbackTypeOptions = [
      {label: this.transPipe.transform('Feedback.Feedback'), value: "Feedback"},
      {label: this.transPipe.transform('Feedback.Error'), value: "Error"},
      {label: this.transPipe.transform('Feedback.MissingFeature'), value: "MissingFeature"},
    ]
    this.feedbackSeverityOptions = [
      {label: this.transPipe.transform('Feedback.FeedbackSeverity.VeryGood'), value: "VeryGood"},
      {label: this.transPipe.transform('Feedback.FeedbackSeverity.Good'), value: "Good"},
      {label: this.transPipe.transform('Feedback.FeedbackSeverity.Problematic'), value: "Problematic"},
      {label: this.transPipe.transform('Feedback.FeedbackSeverity.Critical'), value: "Critical"},
    ]
    this.errorSeverityOptions = [
      {label: this.transPipe.transform('Feedback.ErrorSeverity.Annoyance'), value: "Annoyance"},
      {label: this.transPipe.transform('Feedback.ErrorSeverity.Disturbing'), value: "Disturbing"},
      {label: this.transPipe.transform('Feedback.ErrorSeverity.Critical'), value: "Critical"},
    ]
    this.missingFeatureSeverityOptions = [
      {label: this.transPipe.transform('Feedback.MissingFeatureSeverity.NiceToHave'), value: "NiceToHave"},
      {label: this.transPipe.transform('Feedback.MissingFeatureSeverity.Important'), value: "Important"},
      {label: this.transPipe.transform('Feedback.MissingFeatureSeverity.Essential'), value: "Essential"},
    ]

    this.createFeedbackForm.addControl("feedbackType", new FormControl<FeedbackType | null>(null, [Validators.required]));
    this.createFeedbackForm.addControl("feedbackSeverity", new FormControl<FeedbackSeverityType>("Unknown", feedbackSeverityValidator(this.createFeedbackForm)));
    this.createFeedbackForm.addControl("errorSeverity", new FormControl<ErrorSeverityType>("Unknown", errorSeverityValidator(this.createFeedbackForm)));
    this.createFeedbackForm.addControl("missingFeatureSeverity", new FormControl<MissingFeatureSeverityType>("Unknown", missingFeatureSeverityValidator(this.createFeedbackForm)));
    this.createFeedbackForm.addControl("description", new FormControl<string>("", [Validators.required]));
    this.createFeedbackForm.addControl("concerningPage", new FormControl<string>("", [Validators.required]));
    this.createFeedbackForm.addControl("concerningPetId", new FormControl<string | null>(null));
    this.createFeedbackForm.addControl("concerningTreatmentId", new FormControl<string | null>(null));
    this.createFeedbackForm.addControl("concerningCustomerId", new FormControl<string | null>(null));
    this.createFeedbackForm.addControl("hasPermissionToAccessData", new FormControl<boolean>(false));
    this.createFeedbackForm.addControl("hasPermissionToContact", new FormControl<boolean>(false));
    this.createFeedbackForm.addControl("userAgent", new FormControl<string>(""));
    this.createFeedbackForm.addControl("viewPortWidth", new FormControl<number>(-1));
    this.createFeedbackForm.addControl("viewPortHeight", new FormControl<number>(-1));

    this.createFeedbackForm.patchValue({concerningPage: this.dialogService.getInstance(this.ref)?.data?.concerningPage ?? ""});
    this.subscriptionManager.call(
      this.healthClient.health(),
      (x => {
        this.backendVersion = x.result.version ?? ""
      })
    );
  }


  isInvalid(controlName: string) {
    const control = this.createFeedbackForm.get(controlName);
    return control?.invalid && this.formSubmitted;
  }

  protected SendFeedback() {
    this.formSubmitted = true;
    if (this.createFeedbackForm.valid)
    {
      if (this.createFeedbackForm.value.hasPermissionToAccessData &&
        this.feedbackDataService.feedbackData) {
        if (this.feedbackDataService.feedbackData.customerId) {
          this.createFeedbackForm.patchValue({concerningCustomerId: this.feedbackDataService.feedbackData.customerId});
        }
        if (this.feedbackDataService.feedbackData.petId) {
          this.createFeedbackForm.patchValue({concerningPetId: this.feedbackDataService.feedbackData.petId});
        }
        if (this.feedbackDataService.feedbackData.treatmentId) {
          this.createFeedbackForm.patchValue({concerningTreatmentId: this.feedbackDataService.feedbackData.treatmentId});
        }
      }
      this.createFeedbackForm.patchValue({userAgent: navigator.userAgent})
      this.createFeedbackForm.patchValue({viewPortWidth: window.innerWidth})
      this.createFeedbackForm.patchValue({viewPortHeight: window.innerHeight})
      const feedback = this.createFeedbackForm.value as AddFeedbackDto;
      feedback.backendVersion = this.backendVersion;
      feedback.frontendVersion = this.frontendVersion;
      this.subscriptionManager.call(
        this.feedbackService.addFeedback(feedback),
        (x => {
          if (x.status === 201) {
            this.ref.close(true);
          }
        })
      );
    }
  }

  protected onFeedbackTypeChange() {
    this.createFeedbackForm.patchValue({
      feedbackSeverity: "Unknown",
      errorSeverity: "Unknown",
      missingFeatureSeverity: "Unknown",
    })
  }
}
